import { render, staticRenderFns } from "./ShopStoreGroupbuyOrder.vue?vue&type=template&id=46ee4185&scoped=true"
import script from "./ShopStoreGroupbuyOrder.vue?vue&type=script&lang=js"
export * from "./ShopStoreGroupbuyOrder.vue?vue&type=script&lang=js"
import style0 from "./ShopStoreGroupbuyOrder.vue?vue&type=style&index=0&id=46ee4185&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ee4185",
  null
  
)

export default component.exports